import NoLink from "../../images/nolink.jpg";

const DirectPages = () => {
    return (
        <div className="notification linkouter">
            <div className="notification-inner">
                <div className="notification-link">
                    <img src={NoLink} alt="nolink" />
                </div>
                <p>Page not found. Please check the link.</p>
            </div>
        </div>

    )
}
export default DirectPages;